export interface SearchFolderShare {
  shareId: number;
  sharedWithUserId: number;
  sharedWithUserName: string;
  permission: 'read' | 'write';
  createdAt?: string;
}

export function searchFolderSharesSwrKey(folderId: number): string {
  return `/emails/search-folders/${folderId}/shares`;
}
